
// Initial styles for each section type
export const initialStyles = {
  'text': {
    color: '#333333',
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.5,
  },
  'text-block': {
    color: '#333333',
    fontSize: 16,
    fontWeight: 'normal',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.5,
  },
  'heading': {
    color: '#111111',
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.2,
    margin: '0.5em 0',
  },
  'heading-2': {
    color: '#111111',
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.2,
    margin: '0.5em 0',
  },
  'heading-3': {
    color: '#111111',
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.2,
    margin: '0.5em 0',
  },
  'heading-4': {
    color: '#111111',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'left',
    lineHeight: 1.2,
    margin: '0.5em 0',
  },
  'buttons': {
    backgroundColor: '#4CAF50',
    color: '#ffffff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: 4,
    fontSize: 16,
    text: 'Click Me',
    display: 'block',
    margin: '0 auto',
  },
  'image': {
    src: '',
    alt: 'Image description',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    alignment: 'center',
    fullWidth: true,
    display: 'block',
    margin: '0 auto',
  },
  'divider': {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
  },
  'table': {
    is_bordered: true,
    border: 1,
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    borderCollapse: 'collapse',
    width: '100%',
    opacity: 1,
    thCells: {
      padding: 8
    },
    tbCells: {
      padding: 8
    },
    tHead: {
      backgroundColor: 'rgba(245, 245, 245, 0.75)',
      color: '#333333',
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'left',
      rowHeight: 38,
    },
    tBody: {
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      color: '#333333',
      fontSize: 14,
      fontWeight: 'normal',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'left',
      rowHeight: 38,
    }
  },
  'signature': {
    fontSize: 14,
    fontFamily: 'Arial, sans-serif',
    color: '#666666',
  },
  'qr-code': {
    fontSize: 15,
    placeholder: '{{qr_data}}',
    backgroundColor: '#f5f5f5',
    padding: 16,
    textAlign: 'center'
  },
  'bar-code': {
    fontSize: 15,
    placeholder: '{{barcode_data}}',
    backgroundColor: '#f5f5f5',
    padding: 16,
    textAlign: 'center'
  },
};

export const TEMPLATE_EDITOR_PATHS = {
  TEMPLATES_LIST: (type: string) => `/templates/${type}`,
  TEMPLATES_ADD: (type: string) => `/templates/${type}/:id/add-template`,
  TEMPLATES_EDIT: (type: string) => `/templates/${type}/:id/edit-template/:template_id`,
}

export const STATIONERY_CSS = `
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Kufi+Arabic:wght@400;500;600;700&family=Cairo:wght@400;600;700&display=swap');
.st-head, .st-foot { position: relative !important; overflow: hidden !important; background: transparent !important; font-family: Inter, sans-serif; padding: 0 !important; margin: 0 !important; border: none !important; box-sizing: border-box !important; }
.st-head > *, .st-foot > * { box-sizing: border-box !important; }
.st-free-content { display: flex; align-items: center; justify-content: center; height: 100%; width: 100%; }
.st-free-content > * { margin: 0 !important; width: 100% !important; box-sizing: border-box !important; word-break: break-word; pointer-events: none !important; }
.st-foot-band { display: flex; gap: 15px; align-items: center; white-space: nowrap; font-size: 10px; color: #666; width: 100%; height: 100%; box-sizing: border-box; }
.st-foot-contact { display: flex; gap: 16px; align-items: center; font-size: 11px; color: #444; width: 100%; height: 100%; box-sizing: border-box; }
.st-foot-contact span { display: flex; align-items: center; gap: 4px; }
.st-foot-meta { font-size: 10px; color: #666; display: flex; align-items: center; width: 100%; height: 100%; box-sizing: border-box; }
.st-logo { max-width: 100%; max-height: 100%; object-fit: contain; }
.st-ed-inline { margin: 0; padding: 0; }
.st-name-en { font-size: 16px !important; font-weight: 700 !important; letter-spacing: -0.01em !important; color: #14171b !important; line-height: 1.2 !important; }
.st-name-ar { font-family: 'Noto Kufi Arabic', 'Cairo', 'IBM Plex Sans Arabic', Tahoma, sans-serif !important; font-size: 15px !important; font-weight: 600 !important; color: #3a3f46 !important; line-height: 1.4 !important; direction: rtl !important; unicode-bidi: embed !important; }
.st-tagline { font-size: 10px !important; font-family: 'JetBrains Mono', monospace !important; color: var(--st-brand, #2EB273) !important; }
.st-head--standard .st-name-en,
.st-head--standard .st-name-ar,
.st-head--standard .st-tagline,
.st-head--split .st-name-en,
.st-head--split .st-name-ar,
.st-head--split .st-tagline { text-align: right !important; width: 100% !important; }
.st-head--centered .st-name-en,
.st-head--centered .st-name-ar,
.st-head--centered .st-tagline { text-align: center !important; width: 100% !important; }
</style>
`;